import { Component, ViewChild } from "@angular/core";
import {
  Nav,
  Platform,
  Events,
  AlertController,
  LoadingController,
  App,
  IonicApp,
  Loading,
  MenuController,
  ModalController,
  Config,
} from "ionic-angular";
import { StatusBar } from "@ionic-native/status-bar";
import { SplashScreen } from "@ionic-native/splash-screen";
import { Deeplinks } from "@ionic-native/deeplinks";
import {
  TabsPage,
  EditPegawai,
  LoginPage as LoginMyRadiant,
  NotifikasiPage,
} from "@pages/dashboard";
import {
  LoginPage,
  DashboardPage,
  ListProjectPage,
  ProfilePage,
  AboutPage,
  ProjectDetailPage,
  ListNotificationPage,
} from "@pages/project_mobile";
import {
  User,
  TrackingAsset as Tracking,
  UserAsset,
  LoginMyRadiant as LoginProvider,
  HelperMyRadiant,
  UserMyRadiant,
  NotificationProvider,
} from "../providers";
import { OneSignal } from "@ionic-native/onesignal";
import { AppPresensi } from "@pages/presensi";
import { AppActivity, Employee, MyActivity } from "@pages/activity";
import {
  HomePage as HomeAdvance,
  ListEmployeePage as ListAdvance,
} from "@pages/advance_mobile";
import { AboutApp } from "@pages/about/page";
import { ForbidenloginComponent } from "../components/forbidenlogin/forbidenlogin";
import {
  HomePage as HomeAsset,
  ItemPage,
  LocationPage,
  ConditionPage,
  ClassificationPage,
  TrackingPage,
  ReviewPage,
  LsAssignmentPage,
  DetailItemPage as DetailItemPageAsset,
  AssignmentPage,
} from "@pages/asset";
import {
  LoginPage as LoginPageMarketing,
  DashboardPage as DashboardPageMarketing,
  ListProjectPage as ListProjectPageMarketing,
  ProfilePage as ProfilePageMarketing,
  AboutPage as AboutPageMarketing,
  ListNotificationPage as ListNotificationPageMarketing,
  ProjectDetailPage as ProjectDetailPageMarketing,
} from "@pages/marketing";
import { ListFormPage } from "@pages/survey";
import { ListFormPageDynamic } from "@pages/dynamic_form";
import { ListFormOpnamePage } from "@pages/opname";
import { ChangePasswordPage } from "@pages/changePassword/page";
import { FeedbackProvider } from "../providers/myradiant/feedback/provider";
import { TranslateService } from "@ngx-translate/core";
import {
  ListMasterPageAproval,
  ProfilePageAproval,
  MonitoringPageAproval,
  LoginPageAproval,
} from "@pages/aproval_erp";
import { MonitoringPage } from "@pages/aproval_erp/monitoring/monitoring";
import { FAQPage } from "@pages/faq/page";
// import { BackgroundGeolocation, BackgroundGeolocationConfig, BackgroundGeolocationResponse, BackgroundGeolocationEvents } from '@ionic-native/background-geolocation';
// import * as firebase from 'Firebase';
import { Device } from "@ionic-native/device/ngx";
import { Geolocation } from "@ionic-native/geolocation";
import { Tracker } from "@providers/activity";
import { AppVersion } from "@ionic-native/app-version";
import { Repository } from "@providers/resources/repository";
import { Market } from "@ionic-native/market";
import { BackgroundMode } from "@ionic-native/background-mode";
import BackgroundFetch from "cordova-plugin-background-fetch";
import { Diagnostic } from "@ionic-native/diagnostic";
import { Utility } from "@providers/resources/utility";
// import { delay } from 'rxjs/operator/delay';
import { AndroidPermissions } from "@ionic-native/android-permissions";

@Component({
  templateUrl: "app.html",
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;
  // rootPage = EditPegawai;
  // rootPage:any = AppPresensi;
  rootPage: any = TabsPage;
  // rootPage:any = AboutApp;
  // rootPage:any = AppActivity;
  user: any = {};
  intervalId: any;
  buildApk = this.utility.buildApk;
  debugMode= this.utility.debugMode;
  pages: Array<{
    title: string;
    component: any;
    icon: string;
    pageType: string;
    params: any;
    class?: any;
  }>;
  pages_private: Array<{
    title: string;
    component: any;
    icon: string;
  }>;
  state: any = {
    backMyRadiant: false,
    swipe: true,
    updateApp: false,
  };
  tracking_data: any;
  isLogin = false;
  loading: any;
  has_fitur_approval = false;

  pages_my_radiant: any;
  markers = [];
  // ref = firebase.database().ref('geolocations/');

  constructor(
    public  platform          : Platform,
    public  statusBar         : StatusBar,
    public  splashScreen      : SplashScreen,
    public  events            : Events,
    public  alertCtrl         : AlertController,
    public  loadingCtrl       : LoadingController,
    private app               : App,
    public  modalCtrl         : ModalController,
    private menuCtrl          : MenuController,
    private ionicApp          : IonicApp,
    private oneSignal         : OneSignal,
    public  trackingApi       : Tracking,
    public  userApi           : User,
    public  userMyRadiant     : UserMyRadiant,
    public  userAsset         : UserAsset,
    public  deeplinks         : Deeplinks,
    public  loginProvider     : LoginProvider,
    public  helper            : HelperMyRadiant,
    public  feedbackProvider  : FeedbackProvider,
    public  notifProvider     : NotificationProvider,
    private translate         : TranslateService,
    public  device            : Device,
    public  config            : Config,
    public  geolocation       : Geolocation,
    public  trackerProvider   : Tracker,
    private appVersion        : AppVersion,
    private backgroundMode    : BackgroundMode,
    private repositoryProvider: Repository,
    private market            : Market,
    private diagnostic        : Diagnostic,
    public  utility           : Utility,
    public  androidPermissions: AndroidPermissions
  ) {
    this.backgroundMode.disable();
    this.initializeApp();
    // used for an example of ngFor and navigation
    this.set_pages_myradiant(false);
    this.pages = this.pages_my_radiant;

    platform.ready().then(() => {
      androidPermissions.requestPermissions([
        androidPermissions.PERMISSION.CAMERA,
        androidPermissions.PERMISSION.MANAGE_EXTERNAL_STORAGE,
        androidPermissions.PERMISSION.READ_EXTERNAL_STORAGE,
        androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE,
        androidPermissions.PERMISSION.MANAGE_MEDIA,
        androidPermissions.PERMISSION.ACCESS_MEDIA_LOCATION,
        androidPermissions.PERMISSION.ACCESS_COARSE_LOCATION,
        androidPermissions.PERMISSION.ACCESS_FINE_LOCATION,
        androidPermissions.PERMISSION.ACCESS_BACKGROUND_LOCATION,
        androidPermissions.PERMISSION.ACCESS_NOTIFICATION_POLICY,
        androidPermissions.PERMISSION.LOCATION_HARDWARE,
        androidPermissions.PERMISSION.MANAGE_DOCUMENTS,
        androidPermissions.PERMISSION.INTERNET,
      ]);
    });

    events.subscribe("modul:myradiant", () => {
      this.pages = this.pages_my_radiant;
      this.state.backMyRadiant = false;
      this.state.swipe = true;
    });

    events.subscribe("modul:presensi", () => {
      this.pages = [
        {
          title: "Attendance",
          component: AppPresensi,
          icon: "custom-modul-presensi",
          pageType: "tab",
          params: 0,
        },
        {
          title: "Leave",
          component: AppPresensi,
          icon: "custom-centang",
          pageType: "tab",
          params: 1,
        },
        {
          title: "Permit",
          component: AppPresensi,
          icon: "custom-file",
          pageType: "tab",
          params: 2,
        },
        {
          title: "Overtime",
          component: AppPresensi,
          icon: "custom-clock",
          pageType: "tab",
          params: 3,
        },
        {
          title: "About",
          component: AboutApp,
          icon: "custom-information",
          pageType: "push",
          params: "presensi",
          class: "icon-small",
        },
        {
          title: "FAQ",
          component: FAQPage,
          icon: "custom-faq",
          pageType: "push",
          params: "2",
          class: false,
        },
      ];
      this.state.backMyRadiant = false;
      this.state.swipe = true;
    });

    events.subscribe("modul:activity", () => {
      this.pages = [
        {
          title: "Employee Activity",
          component: AppActivity,
          icon: "custom-menu",
          pageType: "tab",
          params: 0,
        },
        {
          title: "Activity",
          component: AppActivity,
          icon: "custom-clock",
          pageType: "tab",
          params: 1,
        },
        {
          title: "Idle",
          component: AppActivity,
          icon: "custom-jampasir",
          pageType: "tab",
          params: 2,
        },
        {
          title: "About",
          component: AboutApp,
          icon: "custom-information",
          pageType: "push",
          params: "activity",
          class: "icon-small",
        },
        {
          title: "FAQ",
          component: FAQPage,
          icon: "custom-faq",
          pageType: "push",
          params: "8",
          class: false,
        },
      ];
      this.state.backMyRadiant = false;
      this.state.swipe = true;
    });

    events.subscribe("user:has_set_fitur", () => {
      if ("approve_edit_employee" in this.userMyRadiant.akses) {
        this.has_fitur_approval =
          this.userMyRadiant.akses.approve_edit_employee;
        if (this.isLogin) {
          this.set_pages_myradiant(true);
        }
      }
    });

    events.subscribe("modul:advance", () => {
      this.pages = [
        {
          title: "Dashboard",
          component: HomeAdvance,
          icon: "home",
          pageType: "",
          params: null,
        },
        {
          title: "List Advance",
          component: ListAdvance,
          icon: "list",
          pageType: "",
          params: null,
        },
      ];
      this.state.backMyRadiant = false;
      this.state.swipe = true;
    });

    events.subscribe("modul:survey", () => {
      this.pages = [
        {
          title: "List Form",
          component: ListFormPage,
          icon: "list",
          pageType: "",
          params: null,
        },
      ];
      this.state.backMyRadiant = false;
      this.state.swipe = true;
    });

    events.subscribe("modul:form", () => {
      this.pages = [
        {
          title: "List Form",
          component: ListFormPageDynamic,
          icon: "list",
          pageType: "",
          params: null,
        },
      ];
      this.state.backMyRadiant = false;
      this.state.swipe = true;
    });

    events.subscribe("modul:opname", () => {
      this.pages = [
        {
          title: "List Form Opname",
          component: ListFormOpnamePage,
          icon: "list",
          pageType: "",
          params: null,
        },
      ];
      this.state.backMyRadiant = false;
      this.state.swipe = true;
    });

    events.subscribe("modul:aproval_erp", () => {
      this.pages = [
        {
          title: "My Task",
          component: ListMasterPageAproval,
          icon: "",
          pageType: "link",
          params: null,
          class: false,
        },
        {
          title: "Monitoring",
          component: MonitoringPageAproval,
          icon: "",
          pageType: "link",
          params: null,
          class: false,
        },
      ];
      this.state.backMyRadiant = false;
      this.state.swipe = true;
    });

    events.subscribe("modul:project", () => {
      this.pages = [
        {
          title: "Dashboard",
          component: DashboardPage,
          icon: "home",
          pageType: "",
          params: null,
        },
        {
          title: "List Project",
          component: ListProjectPage,
          icon: "list",
          pageType: "",
          params: null,
        },
        {
          title: "About App",
          component: AboutPage,
          icon: "custom-information",
          pageType: "",
          params: null,
        },
      ];
      this.state.backMyRadiant = false;
      this.state.swipe = true;
    });

    events.subscribe("user:access_asset", (res) => {
      // this.user = res.data;
      if (this.userAsset.akses.add_asset) {
        this.pages = [
          {
            title: "Home",
            component: HomeAsset,
            icon: "",
            pageType: "",
            params: null,
          },
          {
            title: "Review",
            component: ReviewPage,
            icon: "",
            pageType: "",
            params: null,
          },
          {
            title: "Activity",
            component: TrackingPage,
            icon: "",
            pageType: "",
            params: null,
          },
          {
            title: "List Asset",
            component: ItemPage,
            icon: "",
            pageType: "",
            params: null,
          },
          {
            title: "Location",
            component: LocationPage,
            icon: "",
            pageType: "",
            params: null,
          },
          {
            title: "Classification",
            component: ClassificationPage,
            icon: "",
            pageType: "",
            params: null,
          },
          {
            title: "Condition",
            component: ConditionPage,
            icon: "",
            pageType: "",
            params: null,
          },
          {
            title: "About",
            component: AboutPage,
            icon: "",
            pageType: "",
            params: null,
          },
        ];
      } else {
        this.pages = [
          {
            title: "Home",
            component: HomeAsset,
            icon: "custom-none",
            pageType: "",
            params: null,
          },
          {
            title: "Review",
            component: ReviewPage,
            icon: "custom-none",
            pageType: "",
            params: null,
          },
        ];
      }
      this.nav.setRoot(HomeAsset);
      this.getTracking();

      this.state.backMyRadiant = false;
      this.state.swipe = true;
      // this.subscribeOneSignal();
    });

    events.subscribe("user:access_marketing", (res) => {
      // if(this.userAsset.akses.add_asset){
      this.pages = [
        {
          title: "Dashboard",
          component: DashboardPageMarketing,
          icon: "home",
          pageType: "",
          params: null,
        },
        {
          title: "List Tender",
          component: ListProjectPageMarketing,
          icon: "list",
          pageType: "",
          params: null,
        },
        {
          title: "About",
          component: AboutPageMarketing,
          icon: "information-circle",
          pageType: "",
          params: null,
        },
      ];
      // }
      this.nav.setRoot(DashboardPageMarketing);
      this.state.backMyRadiant = false;
      this.state.swipe = true;
      // this.subscribeOneSignal();
    });

    events.subscribe("user:check_login", (data) => {
      this.checkLogin(data);
    });

    events.subscribe("user:sign_in", (data) => {
      let me = this;
      this.user = data.data;
      this.isLogin = true;
      this.subscribeOneSignal();
      if (this.has_fitur_approval) {
        this.set_pages_myradiant(true);
      }
      //cara kedua background mode
      //hanafiq disable unutk kebutuhan build yang web
      if (this.buildApk) {
        // this.backgroundMode.enable();
        //When background mode is activated
        if (this.backgroundMode.isEnabled) {
          console.log("is enable background mode");
          this.backgroundMode.on("activate").subscribe(() => {
            console.log("activate background mode");
            this.geolocation
              .getCurrentPosition()
              .then((resp) => {
                // resp.coords.latitude
                // resp.coords.longitude
                let location = resp.coords;
                //console.log(location);
                //clear intervalId
                clearInterval(this.intervalId);
                this.updateGeolocation(location.latitude, location.longitude);
                me.trackerProvider.getInterval().subscribe((resp?: any) => {
                  if (resp.success) {
                    this.intervalId = setInterval(() => {
                      this.updateGeolocation(
                        location.latitude,
                        location.longitude
                      );
                    }, resp.interval);
                  }
                });
              })
              .catch((error) => {
                console.log("Error getting location", error);
              });
          });
        } else {
          //jika belum mode backgrounds
          this.geolocation
            .getCurrentPosition()
            .then((resp) => {
              // resp.coords.latitude
              // resp.coords.longitude
              let location = resp.coords;
              //clear intervalId
              this.updateGeolocation(location.latitude, location.longitude);
              clearInterval(this.intervalId);
              this.trackerProvider.getInterval().subscribe((resp?: any) => {
                if (resp.success) {
                  this.intervalId = setInterval(() => {
                    this.updateGeolocation(
                      location.latitude,
                      location.longitude
                    );
                  }, resp.interval);
                }
              });
            })
            .catch((error) => {
              console.log("Error getting location", error);
            });
        }
        this.geolocation
          .getCurrentPosition()
          .then((resp) => {
            // resp.coords.latitude
            // resp.coords.longitude
            let location = resp.coords;
            //clear intervalId
            this.updateGeolocation(location.latitude, location.longitude);
            clearInterval(this.intervalId);
            this.trackerProvider.getInterval().subscribe((resp?: any) => {
              if (resp.success) {
                this.intervalId = setInterval(() => {
                  this.updateGeolocation(location.latitude, location.longitude);
                }, resp.interval);
              }
            });
          })
          .catch((error) => {
            console.log("Error getting location", error);
          });
      }

      //cara ketiga
      // this.serviceLocation.bind(this);
    });

    events.subscribe("user:sign_out", () => {
      this.isLogin = false;
      this.set_pages_myradiant(false);
      this.userMyRadiant.is_login = 0;
    });

    events.subscribe("user:want_sign_out", () => {
      this.showLoading();
      this.unsubscribeOneSignal();
      this.logout();
      this.events.publish("user:sign_out");
      this.menuCtrl.enable(true, "MainMenu");
      this.loading.dismiss();
      this.set_pages_myradiant(false);
    });

    let ready = true;
    platform.backButton.subscribe(1, () => {
      // alert("asd");
    });
    platform.registerBackButtonAction(() => {
      let activePortal =
        ionicApp._modalPortal.getActive() ||
        ionicApp._overlayPortal.getActive();

      if (activePortal) {
        ready = false;
        activePortal.dismiss();
        activePortal.onDidDismiss(() => {
          ready = true;
        });
        return;
      }

      let view = this.nav.getActive();
      if (view.component == TabsPage) {
        this.confirmExit();
      } else if (
        view.component == DashboardPage ||
        view.component == HomeAdvance ||
        view.component == AppPresensi ||
        view.component == AppActivity ||
        view.component == DashboardPageMarketing ||
        view.component == HomeAsset ||
        view.component == ListMasterPageAproval ||
        view.component == MonitoringPageAproval
      ) {
        this.nav.setRoot(TabsPage, {
          tabIndex: 1,
        });
      } else if (view.component == LoginMyRadiant) {
        this.nav.setRoot(TabsPage, {
          tabIndex: 0,
        });
      } else {
        // this.confirmExit();
        this.nav.pop();
      }
    });
  }

  ngAfterViewInit() {
    this.initDeeplink();
  }

  initDeeplink() {
    this.platform.ready().then(() => {
      let pathPage = {
        "/apps-presensi": {
          modul: AppPresensi,
          modulid: 2,
        },
        "/apps-activity": {
          modul: AppActivity,
          modulid: 8,
        },
        "/apps-advance": {
          modul: HomeAdvance,
          modulid: 7,
        },
      };
      this.deeplinks.routeWithNavController(this.nav, pathPage).subscribe(
        (match) => {
          if ("$link" in match) {
            if (match.$link["fragment"] != "") {
              let frag = match.$link["fragment"].replace("#", "/");
              localStorage.setItem("mainPage", frag);
              if (frag in pathPage) {
                this.loginProvider.getDataLogin((resp_user) => {
                  localStorage.setItem("mainPage", frag);
                  let rootPage = pathPage[frag];
                  if (resp_user) {
                    if ("modul_akses" in resp_user) {
                      let modul_akses = resp_user["modul_akses"],
                        akses = [];
                      if (modul_akses.length > 0) {
                        akses = modul_akses.filter(function (row) {
                          if (
                            row.id == rootPage["modulid"] &&
                            row.hak_akses == 1
                          ) {
                            return row;
                          }
                        });
                      }
                      if (akses && akses.length > 0) {
                        this.nav.setRoot(rootPage["modul"]);
                      }
                    }
                  } else {
                    this.nav.setRoot(rootPage["modul"]);
                  }
                });
              }
            }
          }
        },
        (nomatch) => {
          console.warn("Unmatched Route ", nomatch);
        }
      );
      this.appVersion.getVersionNumber().then(
        (res) => {
          console.log("version", res);
          this.checkUpdateVersion(res);
        },
        (err) => {
          console.log(err);
        }
      );
    });
  }

  deepLinksConfig() {
    let me = this;
  }

  initializeApp() {
    let me = this;
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      //disini
      this.diagnostic
        .isGpsLocationEnabled()
        .then((state) => {
          if (state) {
            // do something
            this.geolocation
              .getCurrentPosition()
              .then((resp) => {})
              .catch((error) => {
                console.log("Error getting location", error);
              });
            localStorage.setItem("stateLoadBerita", "load");
            this.statusBar.overlaysWebView(false);
            this.splashScreen.hide();
            this.statusBar.backgroundColorByHexString("#ffffff");
            this.menuCtrl.enable(true, "MainMenu");
          } else {
            // do something else
            let optionsSwal = {
              title: "Information",
              desc: "Many features require location in this application. Do you want to enable GPS location now ?",
              icon: "",
              dangerMode: false,
              btnCancel: "Later",
              btnConfirm: "Enable Now",
            };
            this.helper.presentSwalConfirmation(optionsSwal, () => {
              //success callback
              this.diagnostic.switchToLocationSettings();
            });
          }
        })
        .catch((e) => console.error(e));
    });
    // firebase.initializeApp(config);
  }

  checkUpdateVersion(version) {
    let params = {
      version: version,
    };
    let me = this;
    this.repositoryProvider.getAppVersion(params).subscribe((resp: any) => {
      if (resp.success) {
        if (resp.status == "update") {
          me.state.updateApp = true;
          const update_notification = this.alertCtrl.create({
            title: "Information",
            enableBackdropDismiss: false,
            message:
              "The latest application version is available. Please update your application.",
            buttons: [
              {
                text: "Not Now",
                handler: () => {},
              },
              {
                text: "Update",
                handler: () => {
                  this.market.open("myradiant.radiant.co.id");
                },
              },
            ],
          });
          update_notification.present();
        } else if (resp.status == "must_update") {
          me.state.updateApp = true;
          const update_notification = this.alertCtrl.create({
            title: "Information",
            message:
              "The latest application version is available. Please update your application.",
            // enableBackdropDismiss: false,
            buttons: [
              {
                text: "Update",
                handler: () => {
                  me.state.updateApp = false;
                  this.market.open("myradiant.radiant.co.id");
                },
              },
            ],
          });
          update_notification.onDidDismiss(() => {
            //console.log("state", me.state.updateApp);
            if (me.state.updateApp) {
              me.checkUpdateVersion(version);
            }
          });
          update_notification.present();
        }
      }
    });
  }

  getTracking() {
    let params: any = {
      status: 0,
    };
    this.trackingApi.get(params).subscribe(
      (resp: any) => {
        if (resp.data.length > 0) {
          this.trackingApi.active = 1;
          this.trackingApi.data = resp.data[0];
          this.tracking_data = this.trackingApi.data;
        }
      },
      (err) => {}
    );
  }

  backMyRadiant(evt) {
    this.nav.setRoot(TabsPage, {
      tabIndex: 1,
    });
    this.events.publish("modul:myradiant");
  }

  openPage(page) {
    let me = this;
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.config.set("backButtonText", "");
    if (page.pageType == "tab") {
      this.nav.setRoot(page.component, {
        tabIndex: page.params,
      });
    } else if (page.pageType == "push") {
      this.nav.push(page.component, {
        params: page.params,
      });
    } else if (page.pageType == "modal") {
      if (page.title == "Feedback") {
        this.helper.presentSwalFeedback((notes, category) => {
          me.loading = me.helper.showLoading("Inserting Your Feedback..");
          me.feedbackProvider
            .add_feedback({
              notes: notes,
              modul_id: category,
              employee_id: this.userMyRadiant.data.Employee_ID,
            })
            .subscribe(
              (resp: any) => {
                try {
                  me.loading.dismiss();
                } catch (error) {}
                if (resp.success) {
                  me.helper.presentSwal(
                    "Success",
                    "Your feedback has been submitted.",
                    "success"
                  );
                }
              },
              (err) => {
                try {
                  me.loading.dismiss();
                } catch (error) {}
              }
            );
        });
      }
    } else {
      this.nav.setRoot(page.component);
    }
  }

  // serviceLocation(){
  //   console.log("kepanggil servicenya");
  //   let fetchCallback = function(taskId) {
  //     console.log('[js] BackgroundFetch event received: ', taskId);
  //     this.geolocation.getCurrentPosition().then((resp) => {
  //       // resp.coords.latitude
  //       // resp.coords.longitude
  //       let location = resp.coords;
  //       //clear intervalId
  //       this.updateGeolocation(location.latitude,location.longitude);

  //     }).catch((error) => {
  //       console.log('Error getting location', error);
  //     });
  //     BackgroundFetch.finish(taskId);
  //   };

  //   let failureCallback = function(error) {
  //       console.log('- BackgroundFetch failed', error);
  //   };

  //   // this.trackerProvider.getInterval().subscribe((resp?:any) => {
  //   //   if (resp.success) {
  //   //     BackgroundFetch.configure(fetchCallback, failureCallback, {
  //   //       minimumFetchInterval: resp.interval // <-- default is 15
  //   //   });
  //   //   }
  //   // });
  //   BackgroundFetch.configure(fetchCallback, failureCallback, {
  //     minimumFetchInterval: 1,
  //     stopOnTerminate:false,
  //   });

  //   BackgroundFetch.scheduleTask({
  //     taskId:"com.myradiant.getLocation",
  //     delay:1000,
  //     stopOnTerminate:false,
  //   },() => {
  //     console.log("schedule success");
  //     this.geolocation.getCurrentPosition().then((resp) => {
  //       // resp.coords.latitude
  //       // resp.coords.longitude
  //       let location = resp.coords;
  //       console.log("location" + location);
  //       //clear intervalId
  //       this.updateGeolocation(location.latitude,location.longitude);

  //     }).catch((error) => {
  //       console.log('Error getting location', error);
  //     });
  //   },failureCallback);

  // }

  showLoading() {
    this.loading = this.loadingCtrl.create({
      content: "Please wait...",
    });
    this.loading.present();
  }

  confirmExit() {
    const confirm = this.alertCtrl.create({
      title: "Yakin akan menutup aplikasi ?",
      buttons: [
        {
          text: "Tidak",
          handler: () => {},
        },
        {
          text: "Ya",
          handler: () => {
            this.platform.exitApp();
          },
        },
      ],
    });
    confirm.present();
  }

  subscribeOneSignal() {
    if (this.platform.is("cordova")) {
      this.oneSignal.startInit(this.userMyRadiant.onesignal_app_id); //, '673452971738'

      this.oneSignal.setSubscription(true);
      this.oneSignal.getIds().then((re) => {
        this.userMyRadiant.player_id = re.userId;
        this.saveStateSubscription(1);
      });

      /* 
      this.oneSignal.getPermissionSubscriptionState().then((resp)=>{
        this.userApi.player_id = resp.subscriptionStatus.userId;
        this.saveStateSubscription(1);
      }) */

      this.oneSignal.inFocusDisplaying(
        this.oneSignal.OSInFocusDisplayOption.Notification
      );

      this.oneSignal.handleNotificationReceived().subscribe((resp) => {
        this.notifProvider.refreshNotification();
        // this.events.publish("notifikasi:reload");
      });

      this.oneSignal.handleNotificationOpened().subscribe((resp) => {
        let arg = resp.notification.payload.additionalData;
        if ("allNotification" in arg) {
          this.notifProvider.refreshNotification();
        }
        if ("readNotification" in arg) {
          let params = {
            employee_id: this.userMyRadiant.data.Employee_ID,
            user_id: this.userMyRadiant.data.id,
            notif_id: arg.app_notification_id,
          };
          this.notifProvider.readNotification(params).subscribe(
            (resp: any) => {
              try {
              } catch (error) {}
              if (resp.success) {
                this.notifProvider.refreshNotification();
              }
            },
            (err) => {}
          );
        }
        if (arg.act == "to_approval_myradiant") {
          this.nav.setRoot(TabsPage, {
            tabIndex: 3,
          });
        }
        if (arg.act == "to_detail_project") {
          this.nav.push(ProjectDetailPage, {
            project_id: arg.project_id,
          });
        }
        if (arg.act == "to_approval_erp") {
          this.nav.push(LoginPageAproval);
          this.events.publish("modul:aproval_erp");
        }
        if (arg.act == "to_detail_asset") {
          this.nav.push(DetailItemPageAsset, {
            id: arg.asset_id,
          });
        }
        if (arg.act == "to_list_assignment") {
          this.nav.push(LsAssignmentPage);
        }
        if (arg.act == "to_permit_bawahan_myradiant") {
          this.nav.setRoot(AppPresensi, {
            tabIndex: 2,
            isNotificationPermit: true,
          });
        }
        if (arg.act == "to_permit_myradiant") {
          this.nav.setRoot(AppPresensi, {
            tabIndex: 2,
            isNotificationPermit: false,
          });
        }
        if (arg.act == "to_overtime_bawahan_myradiant") {
          this.nav.setRoot(AppPresensi, {
            tabIndex: 3,
            isNotificationOvertime: true,
          });
        }
        if (arg.act == "to_overtime_myradiant") {
          this.nav.setRoot(AppPresensi, {
            tabIndex: 3,
            isNotificationPermit: false,
          });
        }
        if (arg.act == "to_assignment") {
          this.nav.push(AssignmentPage);
        }
        if (arg.act == "to_asset_review") {
          this.nav.push(ReviewPage);
        }
        if (arg.act == "to_detail_tender") {
          this.nav.push(ProjectDetailPageMarketing, {
            tender_id: arg.tender_id,
          });
        }
      });

      this.oneSignal.endInit();
    }
  }

  unsubscribeOneSignal() {
    this.oneSignal.setSubscription(false);
    this.saveStateSubscription(0);
  }

  saveStateSubscription(state) {
    let params = {
      player_id: this.userMyRadiant.player_id,
      modul_id: 9,
      user_id: this.userMyRadiant.data.id,
      subscription_state: state,
    };
    this.userMyRadiant.setSubscription(params).subscribe((sub: any) => {});
  }

  login() {
    let forbidenModal = this.modalCtrl.create(ForbidenloginComponent);
    forbidenModal.onDidDismiss((menu) => {
      if (menu == "home") {
        // this.initDeeplink();
        this.nav.setRoot(TabsPage, {
          tabIndex: 0,
        });
      } else {
        this.nav.setRoot(LoginMyRadiant);
      }
    });
    forbidenModal.present();
    // let myItem = localStorage.getItem('stateLoadBerita');
    localStorage.clear();
    // localStorage.setItem('stateLoadBerita',myItem);
    this.menuCtrl.enable(false, "MainMenu");
  }

  confirmLogout() {
    const confirm = this.alertCtrl.create({
      title: "Confirm Logout",
      message:
        "You will not receive a notification after logging out, continue ?",
      buttons: [
        {
          text: "Cancel",
          handler: () => {},
        },
        {
          text: "Yes",
          handler: () => {
            this.showLoading();
            this.unsubscribeOneSignal();
            this.logout();
            this.events.publish("user:sign_out");
            this.menuCtrl.enable(true, "MainMenu");
            this.loading.dismiss();
          },
        },
      ],
    });
    confirm.present();
  }

  logout() {
    let params = {
      user_id: this.userMyRadiant.data.id,
      user_name: this.userMyRadiant.data.user_name,
      user_nik: this.userMyRadiant.data.user_nik,
    };
    this.userMyRadiant.logout(params).subscribe((sub: any) => {});
    // let myItem = localStorage.getItem('stateLoadBerita');
    localStorage.clear();
    // localStorage.setItem('stateLoadBerita',myItem);
    this.nav.setRoot(TabsPage);
  }

  changePassword() {
    this.nav.push(ChangePasswordPage);
  }

  set_pages_myradiant(with_aproval) {
    if (with_aproval) {
      this.pages_my_radiant = [
        {
          title: "Home",
          component: TabsPage,
          icon: "custom-home",
          pageType: "tab",
          params: 0,
        },
        {
          title: "Application",
          component: TabsPage,
          icon: "custom-dashboard",
          pageType: "tab",
          params: 1,
        },
        {
          title: "Profile",
          component: TabsPage,
          icon: "custom-person",
          pageType: "tab",
          params: 2,
        },
        {
          title: "Aproval List",
          component: TabsPage,
          icon: "custom-aproval",
          pageType: "tab",
          params: 3,
        },
        {
          title: "Feedback",
          component: TabsPage,
          icon: "custom-star",
          pageType: "modal",
          params: 0,
          class: "icon-small",
        },
        {
          title: "About",
          component: AboutApp,
          icon: "custom-information",
          pageType: "push",
          params: "myradiant",
          class: "icon-small",
        },
      ];
    } else {
      this.pages_my_radiant = [
        {
          title: "Home",
          component: TabsPage,
          icon: "custom-home",
          pageType: "tab",
          params: 0,
        },
        {
          title: "Application",
          component: TabsPage,
          icon: "custom-dashboard",
          pageType: "tab",
          params: 1,
        },
        {
          title: "Profile",
          component: TabsPage,
          icon: "custom-person",
          pageType: "tab",
          params: 2,
        },
        {
          title: "Feedback",
          component: TabsPage,
          icon: "custom-star",
          pageType: "modal",
          params: 0,
          class: "icon-small",
        },
        {
          title: "About",
          component: AboutApp,
          icon: "custom-information",
          pageType: "push",
          params: "myradiant",
          class: "icon-small",
        },
      ];

      //bisa 1 declaration and then you can push.. so not duplicate code by hanafiq
    }
    this.pages_my_radiant.push({
      title: "FAQ",
      component: FAQPage,
      icon: "custom-faq",
      pageType: "push",
      params: "9",
      class: false,
    });
    this.pages = this.pages_my_radiant;
  }

  checkLogin(callback: any) {
    let is_loginProvider = this.userApi.is_login,
      mainPage = localStorage.getItem("mainPage"),
      isLogin = 0;
    if (localStorage.form_login != undefined) {
      if (is_loginProvider == 0) {
        isLogin = 1;
      } else {
        isLogin = 2;
      }
    }
    if (isLogin == 1 || isLogin == 2) {
      try {
        if (callback) {
          callback();
        }
      } catch (error) {}
    } else if (isLogin == 0) {
      let forbidenModal = this.modalCtrl.create(ForbidenloginComponent);
      forbidenModal.onDidDismiss((menu) => {
        if (menu == "home") {
          this.nav.setRoot(TabsPage, {
            tabIndex: 0,
          });
        } else {
          this.nav.setRoot(LoginMyRadiant);
        }
      });
      forbidenModal.present();
      // let myItem = localStorage.getItem('stateLoadBerita');
      localStorage.clear();
      // localStorage.setItem('stateLoadBerita',myItem);
      this.menuCtrl.enable(false, "MainMenu");
      localStorage.setItem("mainPage", mainPage);
    }
  }

  updateGeolocation(lat, lng) {
    let params = {
      employee_id: this.userMyRadiant.data.employee_id, // you can also add your own properties
      employee_code: this.userMyRadiant.data.code,
      user_id: this.userMyRadiant.data.user_id,
      longitude: lng,
      latitude: lat,
      location: lng + "," + lat,
    };
    this.trackerProvider.update_location(params).subscribe((resp?: any) => {});
  }
}

export const snapshotToArray = (snapshot) => {
  let returnArr = [];

  snapshot.forEach((childSnapshot) => {
    let item = childSnapshot.val();
    item.key = childSnapshot.key;
    returnArr.push(item);
  });

  return returnArr;
};



// WEBPACK FOOTER //
// ./src/app/app.component.ts